import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { setNotificationMessage } from "../../slices/notificationMessageSlice";
import { setNotificationStatus } from "../../slices/notificationStatusSlice";
import "./NotificationBox.css";
import { NotificationType } from "../../enum";
import { useAppDispatch, useAppSelector } from "../../storeHooks";
export const NotificationBox = () => {
    const message = useAppSelector((store) => store.notificationMessage.value);
    const dispatch = useAppDispatch();
    let timer = useRef();
    const clearError = () => {
        dispatch(setNotificationMessage({ message: "", type: null }));
        dispatch(setNotificationStatus(false));
    };
    useEffect(() => {
        timer.current = setTimeout(() => {
            clearError();
        }, 3000);
        return () => {
            if (timer.current) {
                clearTimeout(timer.current);
            }
        };
    });
    const mouseOver = () => {
        if (timer.current) {
            clearTimeout(timer.current);
        }
    };
    const mouseOut = () => {
        timer.current = setTimeout(() => {
            clearError();
        }, 3000);
    };
    return (_jsx("div", { className: message.type == NotificationType.Error
            ? "notification-wrapper error-wrapper"
            : "notification-wrapper", onMouseOver: mouseOver, onMouseOut: mouseOut, children: _jsxs("div", { className: "error-body", children: [_jsx("span", { className: "error-close", onClick: clearError }), message.message] }) }));
};
